import { useLocale } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import {
  GetPremierResidenceListQuery,
  GetPremierResidenceListQueryVariables,
  GetResidenceFormDatasourceQuery,
  GetResidenceFormDatasourceQueryVariables,
  PremierResidenceFooterDatasourceQuery,
  PremierResidenceFooterDatasourceQueryVariables,
  PremierResidenceHeaderQuery,
  PremierResidenceHeaderQueryVariables,
  PremierResidenceNavigationQuery,
  PremierResidenceNavigationQueryVariables,
} from "@/types/generated";

import {
  GET_PREMIER_RESIDENCE_LIST,
  GET_RESIDENCE_FORM,
  PREMIER_RESIDENCE_FOOTER_DATASOURCE,
  PREMIER_RESIDENCE_HEADER,
  PREMIER_RESIDENCE_NAVIGATION,
} from "@/queries/premierResidence";

import { CONTENT_STATUS } from "@/constants";
import { fetchCMS } from "@/graphql/client/client";

export const useGetPremierResidenceHeaderQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceHeaderQuery>({
    queryKey: ["premier-residence-header", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceHeaderQuery>(
        PREMIER_RESIDENCE_HEADER,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
          documentId: "a8192e94d659303f7d1092e6",
        } as PremierResidenceHeaderQueryVariables,
        locale,
      ),
  });
};

export const useGetPremierResidenceMainNavigationQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceNavigationQuery>({
    queryKey: ["premier-residence-main-navigation", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceNavigationQuery>(
        PREMIER_RESIDENCE_NAVIGATION,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
          documentId: "873d943c01cd96786a3160ec",
        } as PremierResidenceNavigationQueryVariables,
        locale,
      ),
  });
};

export const useGetPremierResidenceNavigationQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceNavigationQuery>({
    queryKey: ["premier-residence-navigation", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceNavigationQuery>(
        PREMIER_RESIDENCE_NAVIGATION,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
          documentId: "1d834aedf48f1fbe06a5d732",
        } as PremierResidenceNavigationQueryVariables,
        locale,
      ),
  });
};
export const useGetInquiryFormQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<GetResidenceFormDatasourceQuery>({
    queryKey: ["residence-form-datasource", locale],
    queryFn: () =>
      fetchCMS<GetResidenceFormDatasourceQuery>(
        GET_RESIDENCE_FORM,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
          documentId: "93151d0a14dfd8b005344f63",
        } as GetResidenceFormDatasourceQueryVariables,
        locale,
      ),
  });
};
export const useGetPremierResidenceListQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<GetPremierResidenceListQuery>({
    queryKey: ["premier-residence-list", locale],
    queryFn: () =>
      fetchCMS<GetPremierResidenceListQuery>(
        GET_PREMIER_RESIDENCE_LIST,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
        } as GetPremierResidenceListQueryVariables,
        locale,
      ),
  });
};

export const useGetPremierResidenceFooterNavigationQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceNavigationQuery>({
    queryKey: ["premier-residence-footer-navigation", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceNavigationQuery>(PREMIER_RESIDENCE_NAVIGATION, {
        locale: previewLocale || locale,
        status: previewStatus || CONTENT_STATUS.PUBLISHED,
        documentId: "a87f856038a1aea659684518",
      } as PremierResidenceNavigationQueryVariables),
  });
};

export const useGetPremierResidenceFooterDatasourceQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceFooterDatasourceQuery>({
    queryKey: ["premier-residence-footer-datasource", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceFooterDatasourceQuery>(
        PREMIER_RESIDENCE_FOOTER_DATASOURCE,
        {
          locale: previewLocale || locale,
          status: previewStatus || CONTENT_STATUS.PUBLISHED,
          documentId: "a6c1c098a1d1c380b5b50a8a",
        } as PremierResidenceFooterDatasourceQueryVariables,
      ),
  });
};

export const useGetPremierResidenceHeaderNavigationQuery = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();

  const previewStatus = searchParams.get("status");
  const previewLocale = searchParams.get("locale");

  return useQuery<PremierResidenceNavigationQuery>({
    queryKey: ["premier-residence-header-datasource", locale],
    queryFn: () =>
      fetchCMS<PremierResidenceNavigationQuery>(PREMIER_RESIDENCE_NAVIGATION, {
        locale: previewLocale || locale,
        status: previewStatus || CONTENT_STATUS.PUBLISHED,
        documentId: "1d834aedf48f1fbe06a5d732",
      } as PremierResidenceNavigationQueryVariables),
  });
};
